import React from "react"
import CountBlock from './CountBlock';

function TimeBlock(props) {
    return (
        <div className="time-block">
            <div class="main-container">
                <CountBlock />
            </div>
        </div>
    )
}

export default TimeBlock;